<div class="bg-[--lightRed] rounded-xl min-h-[80vh] mx-4 sm:mx-8 md:mx-16 lg:mx-[200px] my-5">
  <h5 class="text-xs sm:text-sm font-semibold text-center text-white pt-6">
    <i class="bx bx-history text-white"></i> Histórico de Simulados
  </h5>

  <div class="overflow-x-auto bg-white shadow-md rounded-b-xl">
    <table class="min-w-full table-auto text-sm">
      <thead>
        <tr class="bg-gradient-to-r from-blue-600 to-blue-400 text-white">
          <th class="px-4 sm:px-6 py-4 text-left border-b">Título</th>
          <th class="px-4 sm:px-6 py-4 text-left border-b">Corretas</th>
          <th class="px-4 sm:px-6 py-4 text-left border-b">Erradas</th>
          <th class="px-4 sm:px-6 py-4 text-left border-b">Tempo</th>
          <th class="px-4 sm:px-6 py-4 text-left border-b">Data</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of history[0]" class="hover:bg-gray-100 transition-colors">
          <td class="px-4 sm:px-6 py-4 border-b">{{ item.title }}</td>
          <td class="px-4 sm:px-6 py-4 border-b">{{ item.corrects }}</td>
          <td class="px-4 sm:px-6 py-4 border-b">{{ item.wrongs || 0 }}</td>
          <td class="px-4 sm:px-6 py-4 border-b">{{ item.time }}</td>
          <td class="px-4 sm:px-6 py-4 border-b">{{ item.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
